import useErrors from "./useErrors";

function useItemErrors() {
  return useErrors("item");
}

export default useItemErrors;
